import { useMutation } from '../../index';
import permissions from '../../Apollo/permissions';
import { buildVariables, mutation } from './build-standalone-sync-mutation-builder';

export default function useBuildStandaloneSync(options = {}) {
  const [executeMutation, response] = useMutation(mutation, {
    ...options,
    context: { permission: permissions.updatePipelineAJSBuilder },
  });

  const buildStandaloneSyncFile = ({ settingsJson }) => {
    return executeMutation({ variables: buildVariables({ settingsJson }) });
  };

  return [buildStandaloneSyncFile, response];
}
